// extracted by mini-css-extract-plugin
export default {"hovered":"Header_hovered__LOxQ9","header_left_list":"Header_header_left_list__JQFAG","tech__tags":"Header_tech__tags__ottic"};